import QRCode from 'qrcode';
import { SignageTemplate, templatesForCategory } from './SignageTemplate';
import { drawStaticTemplate } from './templateRenderer';

// Question plus an editable button above the reserved live signage QR area.
export const SATISFACTION_TEMPLATES = templatesForCategory('welcome').map((base) => {
  const title = base.fields.find((field) => field.id === 'title');
  const positions = {
    landscape: { x: .09, y: .20, width: .60, height: .39 },
    portrait: { x: .09, y: .20, width: .78, height: .36 },
    banner: { x: .06, y: .16, width: .65, height: .65 },
  };
  if (base.visualStyle === 'split' || base.visualStyle === 'arch') {
    positions.landscape.width = .43; positions.portrait.width = .43;
  }
  if (base.visualStyle === 'photo-top') {
    positions.landscape.y = .43; positions.landscape.height = .25;
    positions.portrait.y = .43; positions.portrait.height = .25;
  }
  if (base.visualStyle === 'sidebar') {
    positions.landscape.x = .23; positions.landscape.width = .46;
    positions.portrait.x = .23; positions.portrait.width = .66;
  }
  return new SignageTemplate({ ...base, id: `survey-${base.visualStyle}`, category: 'satisfaction', fields: [{
    ...title, id: 'title', label: 'Survey question', defaultValue: 'How satisfied are you with our service?',
    required: true, maxLength: 240, multiline: true, positions,
    fontSizes: { landscape: .095, portrait: .095, banner: .30 },
  }, {
    ...title, id: 'callToAction', label: 'QR call to action', defaultValue: 'Scan to vote', required: false,
    maxLength: 80, multiline: true, qrAnchor: 'above-qr',
    positions: { landscape: { x: .74, y: .66, width: .25, height: .07 }, portrait: { x: .74, y: .71, width: .25, height: .07 }, banner: { x: .74, y: .1, width: .25, height: .1 } },
  }] });
});

let demoQr;
async function getDemoQr() {
  if (!demoQr) demoQr = QRCode.toDataURL('https://s.e1e.tv/demo/preview', { width: 500, margin: 4, errorCorrectionLevel: 'M' }).then((source) => new Promise((resolve, reject) => {
    const image = new Image(); image.onload = () => resolve(image); image.onerror = () => reject(new Error('Could not prepare the QR preview.')); image.src = source;
  })).catch((error) => { demoQr = null; throw error; });
  return demoQr;
}

export async function drawSatisfactionTemplate(canvas, template, question, width, height, showQr = false, background, callToAction = 'Scan to vote') {
  // Keep the button outside the QR footprint in both previews and saved images.
  await drawStaticTemplate(canvas, template, { title: question }, width, height, background);
  const ctx = canvas.getContext('2d');
  // Existing non-advertising Android QR layout: 25% width, 1% width margins.
  const size = width * .25, margin = width * .01, x = width - size - margin, y = height - size - margin;
  const label = callToAction.trim();
  if (label) {
    const labelHeight = size * .28, top = y - labelHeight - size * .05;
    ctx.save(); ctx.fillStyle = '#ffffff';
    ctx.beginPath(); ctx.roundRect(x, top, size, labelHeight, labelHeight / 2); ctx.fill();
    ctx.strokeStyle = '#c5a36d'; ctx.lineWidth = Math.max(1, size * .006); ctx.stroke();
    let font = Math.min(size * .11, labelHeight * .35), lines;
    do {
      ctx.font = `600 ${font}px Arial`; lines = [''];
      for (const word of label.split(/\s+/)) {
        const index = lines.length - 1, next = lines[index] ? `${lines[index]} ${word}` : word;
        if (lines[index] && ctx.measureText(next).width > size * .88) lines.push(word); else lines[index] = next;
      }
      if (lines.length <= 2 && lines.length * font * 1.15 <= labelHeight * .72) break;
      font -= .5;
    } while (font > 3);
    ctx.fillStyle = '#203443'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    lines.forEach((line, index) => ctx.fillText(line, x + size / 2, top + labelHeight * .50 + (index - (lines.length - 1) / 2) * font * 1.15, size * .88));
    ctx.restore();
  }
  if (showQr) {
    const qr = await getDemoQr();
    ctx.drawImage(qr, x, y, size, size);
  }
}
